{
  "name": "brains",
  "version": "3.0.4",
  "author": "Bas Gerritsen | RoamerSoft",
  "homepage": "https://roamersoft.com/",
  "privacyPage": "https://privacy.brainssoftware-apps.nl",
  "scripts": {
    "serve": "ionic serve",
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "postinstall": "patch-package",
    "prepare": "husky",
    "e2e": "ng e2e"
  },
  "private": true,
  "overrides": {
    "tar": "^7.5.21",
    "@babel/core": "^7.29.7",
    "esbuild": "^0.28.1",
    "vite": "^7.3.5",
    "undici": "^7.30.1",
    "piscina": "^5.2.0",
    "http-proxy-middleware": "^3.0.7",
    "postcss": "^8.5.18",
    "sharp": "^0.35.5",
    "less": "^4.8.1",
    "@hono/node-server": "^2.0.5",
    "fast-uri": "^3.1.8",
    "qs": "^6.16.0",
    "@xmldom/xmldom": "^0.9.12",
    "webpack-dev-server": "^5.2.6",
    "sockjs": {
      "uuid": "^11.1.1"
    },
    "replace": {
      "minimatch": "^10.2.3"
    },
    "@capacitor/assets": {
      "rimraf": "^6.1.3"
    },
    "@trapezedev/project": {
      "xcode": {
        "uuid": "^11.1.1"
      }
    }
  },
  "dependencies": {
    "@angular/common": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/platform-server": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@angular/service-worker": "^21.2.25",
    "@aparajita/capacitor-biometric-auth": "^9.1.2",
    "@capacitor-community/sqlite": "^7.0.1",
    "@capacitor/android": "^7.0.0",
    "@capacitor/app": "^7.0.0",
    "@capacitor/browser": "^7.0.0",
    "@capacitor/camera": "^7.0.0",
    "@capacitor/core": "^7.0.0",
    "@capacitor/device": "^7.0.0",
    "@capacitor/file-viewer": "^1.0.4",
    "@capacitor/filesystem": "^7.0.0",
    "@capacitor/ios": "^7.0.0",
    "@capacitor/network": "^7.0.2",
    "@capacitor/preferences": "^7.0.0",
    "@capacitor/splash-screen": "^7.0.0",
    "@ionic/angular": "^8.7.5",
    "@ionic/angular-server": "^8.7.5",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "crypto-js": "^4.2.0",
    "interactjs": "^1.10.27",
    "rxjs": "^7.8.2",
    "swiper": "^12.0.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.28",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/cli": "^21.2.28",
    "@angular/compiler": "^21.2.25",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/language-service": "^21.2.25",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.0.2",
    "@ionic/angular-toolkit": "^12.3.0",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~4.3.0",
    "@types/jasminewd2": "~2.0.13",
    "@typescript-eslint/eslint-plugin": "^8.54.0",
    "@typescript-eslint/parser": "^8.54.0",
    "audit-ci": "^7.1.0",
    "eslint": "^9.39.2",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "^46.10.1",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "husky": "^9.1.7",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "patch-package": "^8.0.1",
    "ts-node": "~10.9.1",
    "typescript": "^5.4.5"
  }
}
